var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"popup"}},[(_vm.show)?_c('div',{staticClass:"notification"},[_vm._v(" "+_vm._s(_vm.notificationText ? _vm.notificationText : "undefined, this shouldn't be happening.")+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }